import ReservationPopup from "./ReservationPopup/ReservationPopup";
import ReservationsList from "./ReservationsList";
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { usePropertyId } from "../../../../common/hooks/usePropertyId";
import { withMultipleQueryData } from "../../../../common/withQueryData";
import { useReservationsData } from "../../../../common/hooks/useReservationsData";
import { useRoomsData } from "../../../../common/hooks/useRoomsData";
import { useAlertNotification } from "../../../../common/hooks/useAlertNotification";

const ReservationsPage = () => {
    const propertyId = usePropertyId();

    const { setAlert } = useAlertNotification();

    const navigate = useNavigate();

    const { queryResults: reservationsQueryResults } = useReservationsData(propertyId);
    const { queryResults: roomsQueryResults } = useRoomsData(propertyId);

    const onReservationSelect = (reservationId) => {
        navigate(`${reservationId}`);
    }

    const onCreateReservation = () => {
        setAlert({
            message: "Reservation successfully created!",
            severity: 'success'
        });
    }

    const onDeleteReservation = (reservationId) => {

    }

    return <>
        <ReservationsListWrapperWithMultipleQueryData
            queryResults={{
                reservations: reservationsQueryResults,
                rooms: roomsQueryResults
            }}
            onReservationSelect={onReservationSelect}
            onCreateReservation={onCreateReservation}
            onDeleteReservation={onDeleteReservation}
        />
        <Routes>
            <Route
                path='/:reservationId'
                element={<ReservationPage
                    propertyId={propertyId}
                />}
            />
        </Routes>
    </>
}

const ReservationsListWrapper = ({ queryResults, reloadAll, ...props }) => {
    const { rooms: roomsQueryResult, reservations: reservationsQueryResult } = queryResults;

    /* eslint-disable no-unused-vars */
    const { data: rooms, refetch: reloadRooms } = roomsQueryResult;
    const { data: reservations, refetch: reloadReservations } = reservationsQueryResult;
    /* eslint-enable no-unused-vars */

    return <ReservationsList
        rooms={rooms}
        reservations={reservations}
        {...props}
    />
}

const ReservationsListWrapperWithMultipleQueryData = withMultipleQueryData(
    ReservationsListWrapper
)

const ReservationPage = (props) => {
    const reservationId = useParams().reservationId;

    return <ReservationPopup
        reservationId={reservationId}
        {...props}
    />
}

export default ReservationsPage;